// extracted by mini-css-extract-plugin
module.exports = {"block":"style__block__8uqff","indented":"style__indented__6pYjM","indented_bottom":"style__indented_bottom__LR8Sy","footer":"style__footer__YBAM4"};